import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { SidebarOption } from '../models/sidebar-option';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private http = inject(HttpClient);

  private readonly _isCollapsed = signal<boolean>(true);
  readonly isCollapsed = this._isCollapsed.asReadonly();

  constructor() {
    this.loadOptions();
  }

  loadOptions() {
    return this.http.get<SidebarOption[]>
      ('assets/mocks/sidebar-options.json');
  }

  public toggle() {
    this._isCollapsed.update(v => !v);
  }

  public expand() {
    this._isCollapsed.set(false);
  }

  public collapse() {
    this._isCollapsed.set(true);
  }
}
